import { BackgroundCheckConfig } from '@/backend/features/background-check/defaults';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { SettingData } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';

const getBackgroundCheckConfigSettingManualValue = (singleSettingData: SettingData): BackgroundCheckType | undefined => {
    if (singleSettingData.name === 'backgroundCheckConfig') {
        const value: BackgroundCheckConfig | undefined = singleSettingData?.value ? JSON.parse(singleSettingData.value) : undefined;

        const type = value ? Object.entries(value.type).find(([, value]) => value?.enabled)?.[0] : undefined;

        return type as BackgroundCheckType | undefined;
    }

    return undefined;
};

export function backgroundCheckTypeChanges(
    previousData: SettingData,
    data: SettingData,
): {
    previousBackgroundCheckType: BackgroundCheckType | undefined;
    newBackgroundCheckType: BackgroundCheckType | undefined;
} {
    const previousBackgroundCheckType = getBackgroundCheckConfigSettingManualValue(previousData);
    const newBackgroundCheckType = getBackgroundCheckConfigSettingManualValue(data);

    const backgroundCheckTypeChanged = previousBackgroundCheckType !== newBackgroundCheckType;

    if (!backgroundCheckTypeChanged) {
        return { previousBackgroundCheckType: undefined, newBackgroundCheckType: undefined };
    }

    return { previousBackgroundCheckType, newBackgroundCheckType };
}
